import React, { useState } from 'react'

const QuestionDisclaimer = (props) => {
    const { disclaimer, handleChangeDisclaimer, questionId, disclaimerRequired, handleChangeDisclaimerRequired } = props

    return (
        <div className="mt-4">
            <div className="alert alert-info mt-3">
                <div className="custom-control custom-switch">
                    <input 
                        type="checkbox" 
                        className="custom-control-input" 
                        id="disclaimerToggle" 
                        onChange={(event) => {
                            if (typeof handleChangeDisclaimerRequired === 'function') {
                                const handler = handleChangeDisclaimerRequired(questionId)
                                if (typeof handler === 'function') {
                                    handler(event)
                                }
                            }
                        }} 
                        checked={disclaimerRequired} 
                    />
                    <label className="custom-control-label" htmlFor="disclaimerToggle">
                        Disclaimer Required
                    </label>{' '}
                    <div>
                        <i>*Toggle to enable or disable a disclaimer is required to continue.</i>
                    </div>
                </div>
            </div>
            <div className="mt-3">
                <input className="form-control" type="text" defaultValue={disclaimer} placeholder="Disclaimer text" onChange={handleChangeDisclaimer(questionId)} />
            </div>
            <div className="alert alert-secondary mt-3">You can map responses to questions in the text. For example: #q1# for text questions, or #q1.firstName# for short answer questions, will map the response for question 1 to the text.</div>
        </div>
    )
}

export default QuestionDisclaimer
